import { FontIcons, InputLooks, StandardButton, StandardTextfield } from '@brandfolder/react';
import { t, Trans } from '@lingui/macro';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { TextButton } from '@components/library/button';

import { BackButton } from '../common/BackButton';
import { PersonDetailsParamKeys } from '../customPeopleTagTypes';
import { usePersonDetailsQueryState } from '../hooks/usePersonDetailsQueryState';
import { MockFaceCard, mockFaceCardData } from '../people_page/Home';

const TagPersonWrapper = styled.div`
  align-items: center;
  display: flex;

  button,
  h1,
  img,
  .search-textfield {
    margin-right: 16px;
  }

  img {
    border-radius: 4px;
    height: 48px;
    width: 48px;
  }
`;

const TagPeopleTextfieldWrapper = styled.div`
  align-items: center;
  display: flex;

  .search-textfield {
    width: 300px;
  }
`;

const TitleDivider = styled.hr`
  margin: 40px 0;
`;

const createFaceMap = (details: MockFaceCard[]): MockFaceCard =>
  details.reduce((obj, item) => (obj[item.id] = item, obj), {} as MockFaceCard);
const mockFaceCardMap = createFaceMap(mockFaceCardData);

export const PersonDetailsHeader: FunctionComponent = () => {
  const { id } = useParams();
  const [state, setState] = usePersonDetailsQueryState();
  const [showTagField, setShowTagField] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (mockFaceCardMap[id].label) {
      setState({ tag: mockFaceCardMap[id].label });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <TagPersonWrapper>
        <img alt='person thumbnail' src={mockFaceCardMap[id].imageUrl} />
        <StandardButton
          className={!showTagField && !state.tag ? 'visible' : 'hidden'}
          onClick={(): void => setShowTagField(true)}
          startIcon={FontIcons.Tag}
        >
          <Trans>Tag person</Trans>
        </StandardButton>
        <TagPeopleTextfieldWrapper className={showTagField ? 'visible' : 'hidden'}>
          <StandardTextfield
            id="search-textfield"
            label="Search for people textfield"
            look={InputLooks.Default}
            onChange={(e): void => setState({ [PersonDetailsParamKeys.Tag]: e.target.value })}
            placeholder={t`Enter name`}
            showLabel={false}
            textfieldProps={{ className: 'search-textfield' }}

          />
          <StandardButton
            disabled={!state.tag}
            onClick={(): void => setShowTagField(false)}
          >
            <Trans>Save</Trans>
          </StandardButton>
        </TagPeopleTextfieldWrapper>
        {(!showTagField && state.tag) &&
          <>
            <h1>{state.tag}</h1>
            <TextButton onClick={(): void => setShowTagField(true)}>
              <Trans>Edit</Trans>
            </TextButton>
          </>
        }
      </TagPersonWrapper>
      <TitleDivider />
      <BackButton
        handleNavigateBack={(): void => {
          navigate(`/${BFG.brandfolder_slug}/people_tags`);
        }}
      />
    </>
  );
};
